import Vue from 'vue'

Vue.directive('numeric-only', {
  bind (el) {
    el.addEventListener('keydown', (event) => {
      const allowedKeys = [
        'Backspace', 'ArrowLeft', 'ArrowRight', 'Delete', 'Tab', 'Enter'
      ]

      if ((event.key < '0' || event.key > '9') && !allowedKeys.includes(event.key)) {
        event.preventDefault()
      }
    })

    el.addEventListener('keyup', (event) => {
      const value = event.target.value
      const numericValue = value.replace(/\D/g, '') // Remove non-numeric characters
      event.target.value = numericValue
    })
  }
})

Vue.directive('phone-format', {
  bind (el) {
    let isInternalChange = false

    el.addEventListener('keydown', (event) => {
      // 백스페이스가 입력되었을 때 처리
      if (event.key === 'Backspace') {
        isInternalChange = true
      }
    })

    el.addEventListener('input', (event) => {
      if (isInternalChange) {
        isInternalChange = false
        return
      }

      let value = event.target.value.replace(/\D/g, '') // 숫자가 아닌 문자는 제거
      const originalLength = value.length

      if (value.length > 11) {
        value = value.slice(0, 11) // 최대 11자리까지만 허용
      }

      if (value.length === 9) {
        value = value.replace(/(\d{2})(\d{3})(\d{4})/, '$1-$2-$3')
      } else if (value.length === 10) {
        value = value.replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3')
      } else if (value.length === 11) {
        value = value.replace(/(\d{3})(\d{4})(\d{4})/, '$1-$2-$3')
      }

      const formattedLength = value.length
      const position = event.target.selectionStart

      event.target.value = value
      // 커서 위치 재설정
      if (position !== originalLength) {
        event.target.setSelectionRange(position, position)
      } else {
        const newPosition = position + (formattedLength - originalLength)
        event.target.setSelectionRange(newPosition, newPosition)
      }
    })
  }
})



// WEBPACK FOOTER //
// ./src/script/directive.js